import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "../ui/skeleton";

interface SkeletonCardsGridProps {
  columnsCount: number;
  cardsCount?: number;
}

/**
 * Skeleton del CUERPO de la vista de tarjetas (desktop) del DataTable. No
 * incluye Card/header: se renderiza dentro de la card principal real, para que
 * el header (titulo + toggle) no cambie entre estados.
 */
export default function SkeletonCardsGrid({
  columnsCount,
  cardsCount = 8,
}: SkeletonCardsGridProps) {
  // Campos por tarjeta = columnas visibles menos la primera (que va como titulo).
  const fieldCount = Math.max(columnsCount - 1, 1);

  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(240px,1fr))] max-h-[75vh] gap-3 py-1">
      {Array.from({ length: cardsCount }).map((_, index) => (
        <Card key={index} variant="outline" className="!gap-0 !py-0">
          <CardContent className="flex flex-col gap-1.5 p-3">
            <Skeleton className="h-7 w-3/4" />
            {Array.from({ length: fieldCount }).map((_, fieldIndex) => (
              <div
                key={fieldIndex}
                className="flex items-center justify-between gap-3"
              >
                <Skeleton className="h-5 w-1/3" />
                <Skeleton className="h-5 w-1/2" />
              </div>
            ))}
            <div className="flex gap-3 pt-4">
              <Skeleton className="h-8 flex-1" />
              <Skeleton className="h-8 flex-1" />
              <Skeleton className="h-8 flex-1" />
              <Skeleton className="h-8 flex-1" />
              <Skeleton className="h-8 flex-1" />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
